<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="城市" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/activityTop/create')"
                type="primary"
                icon="el-icon-plus"
                @click="add()"
                size="small"
                >新增置顶演出</el-button
            >
            <el-button
                v-if="$utils.have('/activityTop/listByCity')"
                type="primary"
                icon="el-icon-sort"
                @click="visible = true;"
                size="small"
                >置顶演出排序</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >
                <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="sort" label="序号"></el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="title" label="演出名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column width="170" prop="modifyTime" label="更新时间"></el-table-column>
                <el-table-column fixed="right" width="120" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            v-if="$utils.have('/activityTop/edit')"
                            @click="current = scope.row;updateVisible = true;"
                            >管理</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
				@size-change="handleSizeChange"               
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
        <sort :visible.sync="visible"></sort>
        <update :visible.sync="updateVisible" :detail="current" @onRefresh="fetch"></update>
		<add ref="Add" @onUpdate="fetch"></add>
    </div>
</template>

<script>
import Sort from './components/sort';
import Update from './components/update';
import Add from './components/add';
const defaultQuery = {
    pageNo: 1,    
    queryType: 1,
    queryValue: ''
};
export default {
    components: {
        Sort,
        Update,
		Add
    },
    data() {
        return {
            current: {},
            updateVisible: false,
			addVisible:false,
            visible: false,
           params:{
               ...defaultQuery,
               pageNo:parseInt(this.$route.query.pageNo || 1),
               pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
               queryType: parseInt(this.$route.query.queryType || 1),
               queryValue: this.$route.query.queryValue || '',
			},
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
        };
    },
    mounted(){
        this.fetch();
    },
    methods: {
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/activityTop/list",
                method: "POST",
                data: this.params,
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
      
		//选择pageSize
		handleSizeChange(e) {
		    this.params.pageNo = 1;
		    this.params.pageSize = e;
		    this.fetch();
		},
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.fetch();
		},
		//重置搜索
		reset() {		    
		    this.params = {
		        ...defaultQuery,
		        pageSize: this.params.pageSize,
		    };
		    this.fetch();
		},
		add(){
			this.$refs.Add.show();
		},
        del (id) {
            this.$confirm('确认删除该置顶演出？', '删除置顶演出', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/activityTop/delete",
                    method: "POST",
                    data: {id},
                });
                const {msg, state} = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('置顶演出删除成功');
                this.fetch();
            })
        }
    },
};
</script>